export default () => ({
  logs: {
    results: [],
  },
})
